export const COLOR_SCHEMES = [`light`, `dark`]
export const MEDIA = `(prefers-color-scheme: dark)`
export const IS_SERVER = typeof window === `undefined`
